

@if (data?.session?.lecturerAttendanceClosed) {
  <p-message severity="info" text="{{ 'admin.session-lecturer-attandance-input-group.sessionLocked' | translate }}" styleClass="mt-2"></p-message>
}

@if (type === SessionLecturerType.REGULAR) {
  <ng-container [ngTemplateOutlet]="regular"></ng-container>
}
@if (type === SessionLecturerType.SUBSTITUTION) {
  <ng-container [ngTemplateOutlet]="substitution"></ng-container>
}


<ng-template #regular>
  @if (FG.controls.regularFG) {
    <ng-container [formGroup]="FG.controls.regularFG">
      @if (data?.session; as s) {
        <app-select-button-colored
          [options]="options"
          formControlName="state"
          class="mt-2 block">
        </app-select-button-colored>

        <ng-container [ngTemplateOutlet]="expenses"></ng-container>
      
        @if (FG.controls.regularFG.controls.state.value === SessionLecturerState.PRESENT) {
          @if ((data?.session?.sessionLecturers?.length ?? 0) > 1) {
            <ng-container [ngTemplateOutlet]="lecturingWithInput" [ngTemplateOutletContext]="{fg:FG.controls.regularFG}"></ng-container>
          }
        }
      
        <ng-container *ngTemplateOutlet="noteTemplate"></ng-container>
      }
    </ng-container>
  }
</ng-template>

<ng-template #substitution>
  @if (FG.controls.substitutionFG; as substitutionFG) {
    <ng-container [ngTemplateOutlet]="expenses"></ng-container>

    <ng-container [formGroup]="substitutionFG"> 
      <label class="text-bluegray-400 mt-3 mb-1 text-sm font-bold uppercase block">{{ 'admin.session-lecturer-attandance-input-group.selectevent' | translate }}</label>
      <div class="field">
        <p-listbox
          [options]="sessionGroups"
          [filter]="sessionGroups.length > 7 ? true : false"
          [filterFields]="['shopItem.title']"
          optionLabel="shopItem.title"
          formControlName="sessionGroup"
          [class.loading-box]="fetchingSessionGroups"
          id="sessionGroup"
          styleClass="w-full"
          [listStyle]="{'max-height':'14rem'}">
          <ng-template let-item pTemplate="selectedItem">
            <ng-container [ngTemplateOutlet]="sessionGroupOption" [ngTemplateOutletContext]="{item:item}"></ng-container>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <ng-container [ngTemplateOutlet]="sessionGroupOption" [ngTemplateOutletContext]="{item:item}"></ng-container>
          </ng-template>
        </p-listbox>
        <ng-template #sessionGroupOption let-item="item">
          <div class="flex flex-column">
            <div class="font-bold">
              {{ item.shopItem?.title }}
            </div>
            @if (item; as sg) {
              <div class="details-block-wrap ">
                @if (siHelper.getSessionGroupDate(sg); as sgDate) {
                  <span class="detail-block">
                    {{ sgDate | translate }}
                  </span>
                }
                @if (siHelper.getSessionGroupTime(sg); as sgTime) {
                  <span class="detail-block">
                    {{ sgTime }}
                  </span>
                }
                @if (siHelper.getSessionGroupLocation(sg, true); as sgLocation) {
                  <span class="detail-block">
                    <span class="text-overflow-ellipsis white-space-nowrap overflow-hidden" style="max-width: 17ch;">
                      {{ sgLocation }}
                    </span>
                  </span>
                }
              </div>
            }
          </div>
        </ng-template>
      </div>
    
      @if (substitutionFG.controls.sessionGroup.value) {
        <label class="text-bluegray-400 mt-3 mb-1 text-sm font-bold uppercase block">{{'admin.session-lecturer-attandance-input-group.selectSession' | translate }}</label>
        <div class="field">
          <p-listbox
            [options]="notClosedSessions"
            formControlName="session"
            id="session"
            styleClass="w-full"
            [listStyle]="{'max-height':'12rem'}">
            <ng-template let-item pTemplate="selectedItem">
              <ng-container [ngTemplateOutlet]="sessionOption" [ngTemplateOutletContext]="{item:item}"></ng-container>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <ng-container [ngTemplateOutlet]="sessionOption" [ngTemplateOutletContext]="{item:item}"></ng-container>
            </ng-template>
          </p-listbox>
      
          <ng-template #sessionOption let-item="item">
            <span>
              {{ item.index + 1 }}. {{ 'admin.session-lecturer-attandance-input-group.session' | translate }} -
              {{ item.startAt | localizedDate:'shortDate':undefined:'UTC+0' }}
              <span class="uppercase">
                {{ item.startAt | localizedDate:'EEEEEE':undefined:'UTC+0' }}
              </span>
              {{ item.startAt | localizedDate:'shortTime':undefined:'UTC+0' }}
              {{ item.location?.title }}
            </span>
          </ng-template>
        </div>
      }
    
      @if (substitutionFG.controls.session.value) {
        <ng-container [ngTemplateOutlet]="lecturingWithInput" [ngTemplateOutletContext]="{fg:substitutionFG}"></ng-container>
      }

    
      <ng-container *ngTemplateOutlet="noteTemplate"></ng-container>
    </ng-container>
  }
</ng-template>



<ng-template #lecturingWithInput let-fg="fg">
  <label class="text-bluegray-400 mt-3 mb-1 text-sm font-bold uppercase block">{{ 'admin.session-lecturer-attandance-input-group.lecturing-with-label' | translate }}</label>
  <!-- <label class="mt-3 block"></label> -->
  <div [formGroup]="fg" class="field" [class.loading-box]="lecturersState?.fetchingLecturers$ | async">
    <p-listbox
      [options]="lecturerSelectItems"
      formControlName="lecturingWith"
      [checkbox]="true"
      [showToggleAll]="false"
      [multiple]="true"
      [filterFields]="['label']"
      [filter]="lecturerSelectItems.length > 8 ? true : false"
      [listStyle]="{'max-height':'15rem'}">
    </p-listbox>
  </div>

</ng-template>

<ng-template #expenses>
  <div class="info-card-grid my-3">
    <div (click)="onAddOtherExpenses()" class="info-card cursor-pointer">
      @if (FG.controls.detailsFG.controls.otherExpenses.controls.value.value; as otherExpensesValue) {
        <div class="info-card__title">
          {{ otherExpensesValue }}
        </div>
        <div class="info-card__text">
          {{ 'admin.session-lecturer-attandance-input-group.other-expenses' | translate:{ currency: getCurrencySymbol(FG.controls.detailsFG.controls.otherExpenses.controls.currency.value, 'narrow') } }}
        </div>
      } @else {
        <i class="pi pi-plus info-card__icon"></i>
        <div class="info-card__text">
          {{ 'admin.session-lecturer-attandance-input-group.add-expenses' | translate }}
        </div>
      }
    </div>

    @if ((selectedOrg.selectedOrg$ | async); as org) {
      @if (org.uiSettings?.hideLecturerSalary !== true) {
        <div class="info-card">
          <div class="info-card__title">
            @if (data?.userSessionLecturer?.hourRate && data?.userSessionLecturer?.hourRate?.value !== null) {
              {{ data?.userSessionLecturer?.hourRate?.value }}
            } @else {
              {{ '-' }}
            }
          </div>
          <div class="info-card__text">
            @if (data?.userSessionLecturer?.hourRate?.currency; as currency) {
              {{ getCurrencySymbol(currency, 'narrow') }}
            }
            {{ 'admin.session-lecturer-attandance-input-group.hour-rate' | translate }}
          </div>
        </div>

        @if (getBaseReward(); as baseReward) {
          <div class="info-card">
            <div class="info-card__title">
              {{ baseReward.value }}
            </div>
            <div class="info-card__text">
              {{ 'admin.session-lecturer-attandance-input-group.base-reward' | translate:{ currency: getCurrencySymbol(baseReward.currency, 'narrow') } }}
            </div>
          </div>
        }
        @if (getTotalReward(); as totalReward) {
          <div class="info-card">
            <div class="info-card__title">
              {{ totalReward.value }}
            </div>
            <div class="info-card__text">
              {{ 'admin.session-lecturer-attandance-input-group.total-reward' | translate:{ currency: getCurrencySymbol(totalReward.currency, 'narrow') } }}
            </div>
          </div>
        }
      }
    }


    
  </div>
</ng-template>


<ng-template #noteTemplate>

  <div class="field">
    <textarea [formControl]="FG.controls.detailsFG.controls.note" [rows]="1" [autoResize]="true"  placeholder="{{ 'admin.session-lecturer-attandance-input-group.note-placeholder' | translate }}" pInputTextarea class="w-full"></textarea>
  </div>

</ng-template>


<ng-template #otherExpensesPriceTemplate>
  <app-hour-rate-fg
    [fg]="otherExpensesHelperFG"
    [placeholder]="null"
    [autofocus]="true">
  </app-hour-rate-fg>
</ng-template>